import {
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import {
    INTERCOMPANY_TRANSACTION_SOURCE_LABELS,
    INTERCOMPANY_TRANSACTION_SOURCES,
    INTERCOMPANY_TRANSACTION_STATUSES,
    IntercompanyTransactionSource,
    IntercompanyTransactionStatus,
} from "./intercompanyTransactions.lib";

export const STATUS_TAB = "status";
export const ACCOUNT_TAB = "account";
export const SOURCE_TAB = "source";

export type IntercompanyFilterTab =
    | typeof STATUS_TAB
    | typeof ACCOUNT_TAB
    | typeof SOURCE_TAB;

export const STATUS_OPTIONS: FilterMultiselectOption[] =
    INTERCOMPANY_TRANSACTION_STATUSES.map((status) => ({
        value: status,
        label: status,
    }));

export const SOURCE_OPTIONS: FilterMultiselectOption[] =
    INTERCOMPANY_TRANSACTION_SOURCES.map((source) => ({
        value: source,
        label: INTERCOMPANY_TRANSACTION_SOURCE_LABELS[source],
    }));

export function isStatus(
    value: FilterMultiselectValue,
): value is IntercompanyTransactionStatus {
    return (
        typeof value === "string" &&
        INTERCOMPANY_TRANSACTION_STATUSES.some((status) => status === value)
    );
}

export function isSource(
    value: FilterMultiselectValue,
): value is IntercompanyTransactionSource {
    return (
        typeof value === "string" &&
        INTERCOMPANY_TRANSACTION_SOURCES.some((source) => source === value)
    );
}

export function isAccountId(value: FilterMultiselectValue): value is string {
    return typeof value === "string" && value.length > 0;
}
